/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2021, Zumper
 */

import { getUser } from '@zcode-ui/web-zumper-global-state'
import { IDENTIFY, event } from '@zcode-ui/web-zumper-integrations'
import { getTraktorUserId } from '@zcode/integrations'
import { localStorageSingleton } from '@zcode/nr-utils'
import type { Dispatch } from 'redux'
import { getCurrentLocation } from '../../../inspectors/index'
import type { GetState } from '../../types'

export const syncTraktorIdFromBlueshift = () => (dispatch: Dispatch, getState: GetState) => {
  const currentClientTraktorId = getTraktorUserId(localStorageSingleton)
  const blueshiftTraktorId = localStorageSingleton.get('_TI')
  const isSynced = localStorageSingleton.get(`TI${blueshiftTraktorId}Synced`)
  if (blueshiftTraktorId && currentClientTraktorId !== blueshiftTraktorId && !isSynced) {
    const state = getState()
    const user = getUser(state)
    const location = getCurrentLocation(state)
    const props = {
      TI: blueshiftTraktorId,
      EI: localStorageSingleton.get('_EI'),
      bsft_uid: localStorageSingleton.get('_bsft_uid'),
      bsft_mid: localStorageSingleton.get('_bsft_mid'),
    }
    dispatch(event({ name: IDENTIFY, props, location, user }))
    localStorageSingleton.set(`TI${blueshiftTraktorId}Synced`, true)
  }
}
